<template>
  <div>
    <div class="logo-wrapper pl-5">
      <Logo @click="toggle_sidebar" />
      <div class="back-btn" @click="toggle_sidebar">
        <!-- <i class="fa fa-angle-left"></i> -->
      </div>
      <div class="toggle-sidebar" @click="toggle_sidebar">
        <!-- <vue-feather
          class="status_toggle middle sidebar-toggle"
          type="grid"
          id="sidebar-toggle"
        ></vue-feather> -->
        <svg class="status_toggle middle sidebar-toggle" id="sidebar-menu-toggle">
          <use href="@/assets/svg/newSvgIcon.svg#sidebar-troggle-new"></use>
        </svg>
      </div>
    </div>
    <div class="logo-icon-wrapper pl-0 pr-3" >
      <div>
        <img
          v-if="activeoverlay"
          class="img-fluid pl-2"
          src="../../assets/images/logo/logo-light.png"
          alt=""
          height="35"
          width="80"
        />
      </div>
      <!-- ME logo when side bar is closed -->
      <img
          v-if="!activeoverlay"
          @click=toggle_sidebar
          class="img-fluid"
          src="../../assets/images/logo/Me-logo-set.png"
          alt=""
          height="35"
          width="80"   
        />
    </div>
    <Nav />
  </div>
</template>
<script>
import { mapState } from "vuex";
import Logo from "./logo.vue";
import Nav from "./nav.vue";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: "Sidebar",
  components: {
    Logo,
    Nav,
  },
  computed: {
    ...mapState({
      menuItems: (state) => state.menu.data,
      activeoverlay: (state) => state.menu.activeoverlay,
      togglesidebar: (state) => state.menu.togglesidebar,
    }),
  },
  methods: {
    toggle_sidebar() {
      this.$store.dispatch("menu/opensidebar");
      this.$store.state.menu.activeoverlay = false;
    },

    // For situation sidebar should automatically close on mobile version, and keep closed after change to new page
    // 1. close sidebar only when screen size less than 1000px
    auto_close_sidebar() {
      if (window.innerWidth < 992) {
        this.$store.dispatch("menu/opensidebar"); // assuming this toggles it
        // if(this.activeoverlay) {
        //   this.$store.state.menu.activeoverlay = false;
        // } else {
        //   this.$store.state.menu.activeoverlay = true;
        // }
        // this.$store.state.menu.activeoverlay = false;
      }
    },
  },

  watch: {
    // For situation sidebar should automatically close on mobile version, and keep closed after change to new page
    // 2. watch for route changes to close sidebar
    $route() {
      this.auto_close_sidebar();
    },
  },
};
</script>

